import {gql} from "@apollo/client";

export const GET_JOBS = gql`
	query GetJobs(
		$jobDefinitionId: Int
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: [JobFilterInput!]
		$order: [JobSortInput!]
	) {
		jobs(
			before: $before
			after: $after
			first: $first
			last: $last
			where: { jobDefinition: { id: { eq: $jobDefinitionId } }, and: $where }
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				description
				graphQlQuery
				name
				jobDefinition
				{
				  id
				  name
				  inputType
				  tags {
				  	id
				  	key
				  	value
				  }
				}
				tags {
					id
					key
					value
				}
				anvaSyncStage
				anvaSyncAccount
			}
		}
	}
`;
